type UmamiWindow = Window & {
  umami?: { track?: (event: string, data?: Record<string, unknown>) => void };
};

export const trackEvent = (name: string, data?: Record<string, unknown>): void => {
  if (localStorage.getItem("umami.disabled") === "1") return;
  (window as UmamiWindow).umami?.track?.(name, data);
};

export default trackEvent;
